import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_TRIGGERS } from './actionTypes';
import { getPlcSafetyTriggersSuccess, getPlcSafetyTriggersError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getTriggers({ payload: { user } }) {
  try {
    const response = yield call(plcSafetyAPI.getTriggers, user.token);
    yield put(getPlcSafetyTriggersSuccess(response));
  } catch (error) {
    yield put(getPlcSafetyTriggersError(error));
  }
}

export function* watchGetPlcSafetyTriggers() {
  yield takeEvery(GET_PLC_SAFETY_TRIGGERS, getTriggers);
}

function* getPlcSafetyTriggersSaga() {
  yield all([fork(watchGetPlcSafetyTriggers)]);
}

export default getPlcSafetyTriggersSaga;
